// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1fpmZ","header":"MergedInvoice_header__23POb"};